import React from "react";
import { FaEnvelope, FaWhatsapp, FaInstagram } from "react-icons/fa";

import "../layouts/ConocenosPage.css";
import Titulob from "../assets/pc/contacto/estosomos.png";
import Titulom from "../assets/celu/contacto/somos_enjoy.png";
import TextoInteriorb from "../assets/pc/contacto/titulo4.png";
import TextoInteriorm from "../assets/celu/contacto/Tit_contacto.png";
import vickyw from "../assets/pc/contacto/vicky.png";
import matiasw from "../assets/pc/contacto/matias.png";
import vickym from "../assets/celu/contacto/vicky.png";
import matiasm from "../assets/celu/contacto/matias.png";
function ConocenosPage() {
  const yearStart = 2015;
  const yearNow = new Date().getFullYear();
  const years = yearStart === yearNow ? yearStart : `${yearStart} - ${yearNow}`;
  const isMobile = window.innerWidth < 768;
  const isBig = window.innerWidth > 1900;
  const Titulo = isMobile ? Titulom : Titulob;
  const TextoInterior = isMobile ? TextoInteriorm : TextoInteriorb;
  let vicky = vickyw;
  let matias = matiasw;
  if (isMobile) {
    vicky = vickym;
    matias = matiasm;
  }
  return (
    <section className="conocenos-section" id="section2">
      {/* Mitad superior */}
      <div className="conocenos-top" style={{ marginTop: "50px" }}>
        <img
          className="conocenos-title"
          style={{
            width: isMobile ? "80%" : "40%",
          }}
          src={Titulo}
          alt="Título del Conócenos"
        />
      </div>

      {/* Mitad inferior */}
      <div
        className="conocenos-half"
        style={{
          marginTop: isBig ? "150px" : isMobile ? "90px" : "130px",
        }}
      >
        <img
          className="conocenos-body"
          src={TextoInterior}
          alt="Descripción del Conócenos"
        />{" "}
        <ul
          className="social-list"
          style={{
            marginTop: isMobile ? "-20px" : "20px",
            marginBottom: "-10px",
          }}
        >
          {/* <li>
            <a
              href="https://wa.me/5493512081470"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaWhatsapp style={{ fontSize: "40px" }} />
            </a>
          </li> */}
          <li>
            <a
              href="https://www.instagram.com/enjoyproduccionintegral/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaInstagram style={{ fontSize: "40px" }} />
            </a>
          </li>
        </ul>
        <div className="conocenos-bottom">
          {/* Matías */}
          <div
            className="conocenos-person"
            style={{ marginTop: isMobile ? "-10px" : "-125px" }}
          >
            <p className="conocenos-image">
              <img src={matias} alt="Matías" />
            </p>
            <div className="conocenos-links">
              <div style={{ marginBottom: "-20px" }}>
                <FaEnvelope style={{ color: "white", marginRight: "6px" }} />
                <a
                  className="email-link"
                  href="mailto:matias@enjoy-producciones.com.ar"
                  style={{ wordBreak: "break-word" }}
                >
                  matias@enjoy-producciones.com.ar
                </a>
              </div>
            </div>
          </div>

          {/* Vicky */}
          <div
            className="conocenos-person"
            style={{ marginTop: isMobile ? "-10px" : "-80px" }}
          >
            <p className="conocenos-image">
              {/* <a
                href="https://wa.me/5493512081470"
                target="_blank"
                rel="noopener noreferrer"
                className="conocenos-image"
                aria-label="WhatsApp Vicky"
              > */}
              <img src={vicky} alt="Vicky" />
              {/* </a> */}
            </p>

            <div className="conocenos-links">
              {/* Email primero (igual que Matías) */}
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "6px",
                  marginBottom: isMobile ? "10px" : "4px",
                }}
              >
                <FaEnvelope style={{ color: "white" }} />
                <a
                  className="email-link"
                  href="mailto:victoriaalmada@gmail.com"
                  style={{
                    wordBreak: "break-word",
                    color: "#fff",
                    fontSize: "1em",
                  }}
                >
                  victoriaalmada@gmail.com
                </a>
              </div>

              {/* WhatsApp debajo */}
              <div
                className="contact-row"
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "6px",
                  marginTop: isMobile ? "0px" : "6px",
                }}
              >
                <FaWhatsapp color="white" style={{ fontSize: "1.2em" }} />
                <a
                  href="https://wa.me/5493512081470"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ color: "#fff", fontSize: "1em" }}
                >
                  +54 9 351 208 1470
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="conocenos-footer">
        <p className="footer-text">
          Copyright © {years} ENJOY NIGHT PRODUCCION S.A.
          <span className="footer-cuit">
            {" "}
            CUIT: 30-71481196-3 Todos los derechos reservados.
          </span>
        </p>
      </div>
      {/* Copyright */}
    </section>
  );
}

export default ConocenosPage;
